import { useContext } from 'react'
import ConversationsContext from '../contexts/ConversationsContext'

const useConversations = () => useContext(ConversationsContext)

export * from '../contexts/ConversationsContext'

export default useConversations